import { UNIT_ID_GRAINS_PER_HA, UNIT_ID_GRAINS_PER_M2, UNIT_ID_KG_PER_HA } from '@/products/constants';

export type SeedingWorkflowType = 'Maize' | 'Soy';

export type SeedingWorkflowConfig = {
  workflowName: SeedingWorkflowType;
  indexType: string;
  configSet: string;
  getUnitId: (seedingMethod?: string) => string;
  shouldConvertM2ToHa: boolean;
  conversionFactor: number;
  invertColorScale?: boolean;
};

export const MAIZE_WORKFLOW_CONFIG: SeedingWorkflowConfig = {
  workflowName: 'Maize',
  indexType: 'RATE_SEED_MAIZE',
  configSet: 'SET_A2',
  getUnitId: () => UNIT_ID_GRAINS_PER_HA,
  shouldConvertM2ToHa: false,
  conversionFactor: 1,
};

export const SOY_WORKFLOW_CONFIG: SeedingWorkflowConfig = {
  workflowName: 'Soy',
  indexType: 'RATE_SEED_MAIZE',
  configSet: 'SET_A2',
  getUnitId: (seedingMethod?: string) => (seedingMethod === 'Drill' ? UNIT_ID_KG_PER_HA : UNIT_ID_GRAINS_PER_M2),
  shouldConvertM2ToHa: true,
  conversionFactor: 10000, // M2_TO_HA
  invertColorScale: true,
};
